import PropTypes from 'prop-types'
import styled from 'styled-components'
import Input from 'components/Input'
import Stack from '@mui/material/Stack'

const SIZES = {
  sm: {
    fontCurrency: 'dataLarge',
    fontInput: 'valueLargeLight',
    currencyOffset: 7,
    inputWidth: 30,
  },
  md: {
    fontCurrency: 'valueLarge',
    fontInput: 'valueXLarge',
    currencyOffset: 20,
    inputWidth: 57,
  },
}

const Currency = styled.div`
  ${props => props.theme.typography[SIZES[props.size].fontCurrency]}
  position: relative;
  top: ${props => SIZES[props.size].currencyOffset}px;
  text-align: right;
`

const StyledInput = styled(Input)`
  ${props => props.theme.typography[SIZES[props.styledSize].fontInput]}
  // opacity: ${props => (props.value == 0 ? '.25' : '1')};
  width: ${props => (props.value?.length - (props.value % 1 > 0 ? .8 : 0))}ch;
  min-width: 1.1ch;
  max-width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;

  &:placeholder {
    opacity: 1;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

// const formatValue = value => {
//   const numberValue = Number(value);
//   if (Number.isNaN(numberValue)) return ''

//   if (numberValue % 1 === 0) return String(numberValue)

//   return String(numberValue.toFixed(2))
// }

const CurrencyInput = ({ id, size, align, value, max, onChange }) => (
  <Stack
    display="inline-grid"
    gridAutoFlow="column"
    justifyContent={align === 'center' ? 'center' : 'flex-start'}
    alignItems="flex-start"
    position="relative"
    minWidth="1px"
    left={align === 'center' ? '-10px' : '0'}
  >
    <Currency size={size}>$</Currency>
    <StyledInput
      id={id}
      styledSize={size}
      align={align}
      placeholder="0"
      value={value}
      max={max}
      mask="currency_no_prefix"
      selectOnFocus
      onChange={(data, validity) => {
        onChange(data?.toString().replaceAll(',', ''), validity)
      }}
    />
  </Stack>
)

CurrencyInput.propTypes = {
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  align: PropTypes.oneOf(['left', 'center']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.string,
  onChange: PropTypes.func,
}

CurrencyInput.defaultProps = {
  size: 'md',
  align: 'left',
  max: '2500',
  onChange: () => {},
}

export default CurrencyInput
